import { useEffect, useState } from 'react';
import { usePitchesStore } from '../store/usePitchesStore'; // Zustand store import
import love_diamond from '../assets/images/love_diamond.png';
import camera_icon from '../assets/images/camera_icon.png';
import { Link, useNavigate } from 'react-router-dom';
import moment from "moment";
import { useSendLikeStore } from '../store/useSendLikeStore';
import { Button, Modal } from "react-bootstrap";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useSubscriptionStore } from '../store/useSubscriptionStore';
import useAuthStore from '../store/useAuthStore';
import { hasPremiumAccess } from '../utils/subscription'; 
import { useUserStore } from '../store/useUserStore';
import { getSizedImageUrl } from '../utils/getSizedImageUrl';
import defaultimg from '../assets/images/default413.png';
const MySwal = withReactContent(Swal);


const LikedListPage = () => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const { loadinglike, sendLike } = useSendLikeStore();
  const [showModal, setShowModal] = useState(false);
  
  // Accessing Zustand store for pitches and pagination data
  const { rows, totalPages, loading, getPitches,deleteRequest } = usePitchesStore();
  const {newRequest } = useUserStore();
  const { paymentDetails, getSubscription } = useSubscriptionStore();
  const [resolvedImages, setResolvedImages] = useState<string[]>([]);

  const authStore = useAuthStore.getState();
  useEffect(() => {
    // Trigger the getPitches action when page or search term changes
    getPitches(page);
    getSubscription(authStore.user?.id)
  }, [page, getPitches]);
    useEffect(() => {
      // Trigger the getPitches action when page or search term changes
      getPitches(1);
    
    }, []);
  useEffect(() => {
    const interval = setInterval(async () => {
      if(newRequest.newRequestCount>0){
        getPitches(page);
      }
     
   }, 3000); // 60000 ms = 1 minute
  return () => clearInterval(interval); // Cleanup on unmount
  }, [newRequest?.newRequestCount, page]);

useEffect(() => {
  const resolveImageUrls = async () => {
    const promises = rows.map(async (pitch: any) => {
      const sizedUrl = await getSizedImageUrl(pitch.user_photos[0]?.picture, '389x438');
      return sizedUrl || pitch.user.pic;
    });

    const result = await Promise.all(promises);
    setResolvedImages(result);
  };

  resolveImageUrls();
}, [rows]);



  const handlePageChange = (newPage:any) => {
    setPage(newPage);
  };
  const handleLike = async (pitch:any) => {
    await sendLike(pitch.user.id, 50, "", pitch.id);
    getPitches(page);
    setShowModal(true); // Show modal after liking
  };

  const confirmDeleteRequest = (requestId:any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Delete Request?</h3>
          <p>Do you really want to delete this request?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button className="btn btn-danger" onClick={() => { 
              deleteRequest(requestId); 
              MySwal.close();
            }}>
              Yes, Delete
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };

   const showUpgradePlanAlert = () => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Upgrade Plan</h3>
          <p>Upgrade your plan to send more messages.</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Close
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                MySwal.close();
                navigate('/settings#subscription');
              }}
            >
              Upgrade Now
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };
  const isPremium = hasPremiumAccess(paymentDetails);
  return (
    <section className="py-60 bg-light dating_liked_list_page">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 mb-3">
            <div className="row g-3">
              {loading ? (
                <div className="text-center">
                  <div className="loader mb-2"></div>
                  <h5>Loading...</h5>
                </div>
               ) : rows.length === 0 ? (
                <div className="py-5 px-2">
                  <div className="msspopup msspopup2" style={{ pointerEvents: 'all' }}>
                    <div>
                      <div className="row position-relative">
                        <div className="col-md-12">
                          <h4 className="text-center text-pink">Active Hits</h4>
                        </div>
                        <div className="col-md-12 iocdiv"></div>
                      </div>
                
                      <h5 className="text-center">You have no new hits</h5>
                      <h6 className="text-center">
                        Update your <Link to="/myprofile"><span className="text-primary">profile</span></Link> to stand out or go to{' '}
                        <Link to="/dashboard"><span className="text-primary">send likes</span></Link> to meet new singles.
                      </h6>
                    </div>
                  </div>
                </div>
              
                ) : (
                  rows.map((pitch: any, index: number) => {
                    const isBlurred = !isPremium && index >= 2;
                    const imgSrc = resolvedImages[index] || pitch.user.pic || defaultimg;
                    
                  
                    return (
                      <div className="col-lg-4 col-md-6" key={index} >
                        <div className={`dp_list_liked_card ${isBlurred ? "blurred" : ""}`}>
                        
                            <div className="dp_list_liked_card_img" onClick={() => {
                              if (!isBlurred) {
                                navigate(`/liked-profile/${pitch.user.id}/${pitch.id}`);
                              }else{
                                showUpgradePlanAlert();
                              }
                            }}
                            >
                              <img
                                src={imgSrc}
                                className="img-fluid"
                                alt=""
                              />
                              <span className="dp_list_box_span">
                                {pitch.user_photos.length === 0 ? 1 : pitch.user_photos.length}+{" "}
                                <img src={camera_icon} alt="" />
                              </span>
                            </div>
                         
                          <div className="dp_list_liked_card_cnt">
                            <h3>{pitch.user.first_name}, {pitch.user.age}</h3>
                            <p>{moment(pitch.user.is_online).fromNow()}</p>
                            <div className="dp_actions_btngroup border-top">
                              <div className="dp_actions_btn_item">
                                <button className="btn pass_btn" onClick={isBlurred ? undefined : () => confirmDeleteRequest(pitch.id)}>
                                  <i className="fa-solid fa-xmark"></i>
                                </button>
                              </div>
                              {pitch.messages.length > 0 ?
                              <div className="dp_actions_btn_item">
                                <button className="btn message_btn position-relative" onClick={() => {
                              if (!isBlurred) {
                                navigate(`/liked-profile/${pitch.user.id}/${pitch.id}`);
                              }
                            }}>
                                  <i className="fa-solid fa-paper-plane"></i>
                                  <span className="badge bg-danger">
                                    {pitch.messages.length}
                                  </span>
                                </button>
                              </div>
                              : '' }
                              <div className="dp_actions_btn_item">
                                <button
                                  className="btn like_btn"
                                  data-bs-toggle="modal"
                                  data-bs-target="#matchedlikeModel"
                                  onClick={isBlurred ? undefined : () => handleLike(pitch)}
                                  disabled={loadinglike || isBlurred} // Disable if blurred
                                >
                                  <i className="fa-regular fa-heart"></i>
                                </button>
                  
                               
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
              )}
            </div>

             {/* Pagination */}
       {rows.length > 0 && isPremium ?       
        <div className="col-lg-12">
          <nav className="custom_pagination_wrapper">
            <ul className="pagination">
              <li className="page-item">
                <a className="page-link" href="#" aria-label="Previous" onClick={() => handlePageChange(page - 1)}>
                  <i className="fa-solid fa-chevron-left"></i>
                </a>
              </li>
              {[...Array(totalPages)].map((_, index) => (
                <li className={`page-item ${page === index + 1 ? 'active' : ''}`} key={index}>
                  <a
                    className="page-link"
                    href="#"
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </a>
                </li>
              ))}
              <li className="page-item">
                <a className="page-link" href="#" aria-label="Next" onClick={() => handlePageChange(page + 1)}>
                  <i className="fa-solid fa-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        :''}
          </div>

          <div className="col-lg-3">
            {paymentDetails && paymentDetails.status==1 ? '' : 
            <div className="card text-start">
              <div className="mb-2">
                <img src={love_diamond} className="img-fluid" />
                <h5 className="font18 mb-3">Upgrade to discover who's interested in you.</h5>
                <Link  to={'/settings#subscription'} className="btn btn-outline-primary py-2">Upgrade</Link>
              </div>
            </div>    
            }
          </div>
        </div>

       
      </div>

       {/* Match Modal */}
                                <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                                  <Modal.Header closeButton />
                                  <Modal.Body className="text-center py-5 px-4">
                                    <img src={love_diamond}  alt="" className="dp_user_img mb-3" />
                                    <h3>🎉 It's a Match! 🎉</h3>
                                    <p>
                                      Start exploring your connection with the Love Diamond, where you can express your interest.
                                      Make the first move and send a message!
                                    </p>
                                    <Button onClick={() => {navigate(`/matched`);}} variant="primary" className="py-2">Start Chatting</Button>
                                  </Modal.Body>
                                </Modal>
    </section>
  );
};

export default LikedListPage;
